import { NavLink, Outlet } from "react-router-dom";
import "../body.css"

import React, { useEffect } from "react";

function Essays() {
    useEffect(() => {
        document.title = "Josiah Swanson - Essays";
    }, []);
    return (
        <>
            <section>
                <h2 className="centeredp">Essays</h2>
                <nav style={{ margin: "0 0 55px 0" }} className="essayhorizontalnav">
                    <NavLink style={{ display: "inline-block", padding: "0 10px" }} className={({ isActive }) => isActive ? "selectedlink" : "notselectedlink"} to="winwin">Win-Win</NavLink>
                    <NavLink style={{ display: "inline-block", padding: "0 10px" }} className={({ isActive }) => isActive ? "selectedlink" : "notselectedlink"} to="christiantech">Christian Technology</NavLink>
                    <NavLink style={{ display: "inline-block", padding: "0 10px" }} className={({ isActive }) => isActive ? "selectedlink" : "notselectedlink"} to="symbols">Symbols are Not Enough</NavLink>
                </nav>
                <Outlet />
            </section>
        </>
    );
}

export default Essays;
